export type {
  SkeletonItemSlots,
  SkeletonItemBaseProps as SkeletonItemProps,
  SkeletonItemBaseState as SkeletonItemState,
} from '@fluentui/react-skeleton';
